$component-class: 'testimonials-type-4';

.#{$component-class} {
  &__intro {
    .me-text {
      @include text-style('md', 'md');

      @include desktop {
        @include text-style('lg', 'md');

        max-width: 70%;
        margin-left: auto;
        margin-right: auto;
      }
    }
  }

  &__carousel {
    position: relative;
    min-height: 300px; // Ensure carousel has minimum height for absolute positioning
  }

  &__slide {
    transition: opacity 0.3s ease-in-out;
    opacity: 0;
    will-change: opacity;

    &--active {
      opacity: 1;
      position: relative;
      z-index: 1;
    }

    &--hidden {
      opacity: 0;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      pointer-events: none;
      z-index: 0;

      // Keep in DOM for SEO, but visually hidden
      // Height will be determined by active slide

      // Prevent focus on all focusable elements inside hidden slide
      // Note: tabindex is set via JavaScript in componentDidUpdate
      a:focus,
      button:focus,
      [tabindex]:focus,
      input:focus,
      select:focus,
      textarea:focus {
        outline: none;
      }
    }

    // When both active and transitioning, use lower opacity
    // This selector has higher specificity than just --active
    &--active.#{$component-class}__slide--transitioning {
      opacity: 0.7;
      transition: opacity 0.3s ease-in-out;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;

    .section-subtitle {
      font-weight: map-get($font-weights, 'bold');
    }
  }

  &__rating-author {
    display: flex;
    align-items: center;
    gap: var(--spacing-md);
    margin-bottom: var(--spacing-xl);

    @include desktop {
      margin-bottom: var(--spacing-2xl);
    }
  }

  &__rating {
    display: flex;
    gap: 4px;
  }

  &__author {
    margin: 0;
  }

  &__heading {
    margin-bottom: var(--spacing-lg);

    @include desktop {
      margin-bottom: var(--spacing-xl);
    }
  }

  &__subheading {
    margin-bottom: var(--spacing-lg);

    @include desktop {
      margin-bottom: var(--spacing-xl);
    }
  }

  &__read-more {
    &.me-button {
      color: var(--action-color-brand-primary);
      font-weight: map-get($font-weights, 'bold');

      &:hover {
        color: var(--action-color-brand-primary-hover);

        &::before {
          background-color: var(--action-color-brand-primary-hover);
        }
      }
    }

    @include desktop {
      margin-top: var(--spacing-xl);
    }
  }

  &__text {
    .me-heading {
      margin-bottom: var(--spacing-xl);

      @include desktop {
        margin-bottom: var(--spacing-2xl);
      }
    }
  }

  &__footer {
    margin-top: var(--spacing-xl);

    @include desktop {
      margin-top: var(--spacing-2xl);
    }
  }

  &__decoration {
    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }

  &__navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: var(--spacing-2xl);
    gap: var(--spacing-lg);

    @include desktop {
      margin-top: var(--spacing-3xl);
    }
  }

  &__dots {
    display: flex;
    gap: var(--spacing-sm);
    align-items: center;
    flex: 1;
    justify-content: flex-start;
  }

  &__dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    border: none;
    background-color: var(--color-neutral-neutral);
    cursor: pointer;
    padding: 0;
    transition:
      background-color 0.2s ease,
      transform 0.2s ease;

    &:hover {
      background-color: var(--color-neutral-black);
      transform: scale(1.2);
    }

    &:focus-visible {
      outline: 2px solid var(--color-neutral-black);
      outline-offset: 2px;
    }

    &--active {
      background-color: var(--color-neutral-black);
      transform: scale(1.2);
    }
  }

  &__arrows {
    display: flex;
    gap: var(--spacing-sm);
  }

  &__arrow {
    .me-button {
      min-width: 40px;
      min-height: 40px;
      border-radius: 50%;

      &::after {
        border-radius: 50%;
      }

      &:focus,
      &:focus-visible {
        &::after {
          inset: -4px;
          border-radius: 50%;
        }
      }
    }
  }
}
